/* ============================================================
   FLIPSI V3 — the ? curiosity seal + V3 copy layer (23 Jul 2026)
   Standalone on purpose: flipsi-canonical.js stays untouched, so the
   approved interaction registry carries zero regression risk. Same
   rules as canonical: idempotent binding, editor re-render safe
   (shopify:section:load), keyboard-native, reduced-motion via CSS.

   1 · [data-flipsi~="curiosity"] — a .fsq wrapper with one .fsq-seal-btn
       and one .fsq-panel. The seal is a real button: press to turn a
       quarter and unfold the note; close re-seals. A ? always opens
       something; it is never decoration.
   2 · Chooser copy sweep — the house writes without em dashes now.
       The five legacy strings rendered by canonical's chooser are
       corrected at render time via exact-match replacement, scoped to
       the chooser mount only. Fold into canonical.js on the next
       deliberate edit of that file, then delete part 2 here.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- 1 · curiosity seals ---------- */
  function bindCuriosity(scope) {
    scope = scope || document;
    var roots = Array.prototype.slice.call(scope.querySelectorAll('[data-flipsi~="curiosity"]'));
    if (scope.matches && scope.matches('[data-flipsi~="curiosity"]')) roots.unshift(scope);
    roots.forEach(function (root) {
      if (root.dataset.fsqBound) return;
      var btn = root.querySelector('.fsq-seal-btn');
      var panel = root.querySelector('.fsq-panel');
      if (!btn || !panel) return;
      root.dataset.fsqBound = '1';
      function focusable(open) {
        var els = panel.querySelectorAll('a, button');
        for (var i = 0; i < els.length; i++) {
          if (open) { els[i].removeAttribute('tabindex'); } else { els[i].setAttribute('tabindex', '-1'); }
        }
      }
      function setOpen(open) {
        root.classList.toggle('fsq-open', open);
        btn.setAttribute('aria-expanded', String(open));
        panel.setAttribute('aria-hidden', String(!open));
        focusable(open);
      }
      setOpen(false);
      btn.addEventListener('click', function () { setOpen(!root.classList.contains('fsq-open')); });
      var cl = root.querySelector('.fsq-close');
      if (cl) cl.addEventListener('click', function () { setOpen(false); btn.focus(); });
    });
  }

  /* ---------- 2 · chooser copy sweep (exact strings only) ---------- */
  var FIX = [
    ['You said surprise me — this is where most people start.', 'You said surprise me. This is where most people start.'],
    ['Not sure is a fine place to start — Plus is where most people do.', 'Not sure is a fine place to start. Plus is where most people do.'],
    ['Between production runs — reserving reopens with the next one.', 'Between production runs. Reserving reopens with the next one.'],
    ['Held in the next production run — window shown before you commit.', 'Held in the next production run, window shown before you commit.'],
    [' — ', ' · ']
  ];
  function sweep(mount) {
    var html = mount.innerHTML;
    var out = html;
    for (var i = 0; i < FIX.length; i++) { out = out.split(FIX[i][0]).join(FIX[i][1]); }
    if (out !== html) mount.innerHTML = out;
  }
  function watchChooser(scope) {
    (scope || document).querySelectorAll('[data-fs-mount]').forEach(function (mount) {
      if (mount.dataset.fsqSweep) return;
      mount.dataset.fsqSweep = '1';
      var mo = new MutationObserver(function () { sweep(mount); });
      mo.observe(mount, { childList: true, subtree: false });
      sweep(mount);
    });
  }

  function boot() { bindCuriosity(document); watchChooser(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { bindCuriosity(e.target); watchChooser(e.target); });
})();
